<template>
  <!-- NOTE (TEMPLATE) to show the university login page -->

  <div class="app animated fadeIn flex-row align-items-center uniBack">
    <!-- loading component -->
    <Loading />
    <!-- reset pass  -->
    <b-modal
      id="resetPassModal"
      ref="resetPassModal"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
      centered
    >
      <template v-slot:modal-header>
        <h4>بازیابی رمز عبور</h4>
      </template>
      <template v-slot:modal-footer>
        <b-button
          variant="danger"
          size="lg"
          class="btn-radius px-8 py-2 mt-4"
          @click="closeResetPass()"
          >لغو</b-button
        >
      </template>
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="10">
            <!-- NOTE here, the user will enter the username  -->
            <div v-if="!codeSent">
              <p>
                لطفا نام کاربری خود را وارد نموده تا کد بازیابی برای شما ارسال
                گردد
              </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-user"></i>
                  </b-input-group-text>
                </b-input-group-prepend>

                <b-form-input
                  trim
                  type="text"
                  v-model="username"
                  class="form-control"
                  placeholder="نام کاربری"
                  @keyup.enter.native="!busy && username ? sendCode() : ''"
                />
              </b-input-group>
              <b-button
                v-if="!codeSent"
                type="submit"
                variant="primary"
                @click="sendCode()"
                style="border: 0"
                :disabled="busy || !username"
                class="btn-radius px-8 py-2 mt-4"
              >
                <i class="icon-login"></i>ارسال کد بازیابی
              </b-button>
            </div>
            <!-- NOTE then after the activation code has been sent, here, the user will enter 
            the activation and the new pass -->
            <div v-else>
              <p>
                لطفا کدی را که اکنون به شما پیامک کردیم را به همراه رمز عبور
                جدید وارد نمایید
              </p>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  trim
                  type="number"
                  :no-wheel="true"
                  v-model="activationCode"
                  class="form-control"
                  placeholder="کد ارسالی"
                  autofocus
                />
              </b-input-group>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  trim
                  type="password"
                  v-model="newPass"
                  class="form-control"
                  placeholder="رمز عبور جدید"
                  @input="passStrength"
                  autofocus
                />
              </b-input-group>
              <!--============== checking password =========== -->
              <b-row>
                <b-col>
                  <!-- NOTE check if the pass has more than 8 charector -->
                  <p
                    class="pass"
                    :class="{ 'pass--passed': newPass.length > 7 }"
                  >
                    <i
                      class="frmIcon fa"
                      :class="newPass.length > 7 ? 'fa-check' : 'fa-times'"
                    ></i>
                    حداقل ۸ نویسه
                  </p>
                </b-col>
                <b-col>
                  <!-- NOTE check if the pass has uppercase -->
                  <p
                    class="pass"
                    :class="{ 'pass--passed': rec_has_uppercase }"
                  >
                    <i
                      class="frmIcon fa"
                      :class="rec_has_uppercase ? 'fa-check' : 'fa-times'"
                    ></i>
                    دارای حروف بزرگ باشد
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <!-- NOTE check if the pass has lowercase -->
                  <p
                    class="pass"
                    :class="{ 'pass--passed': rec_has_lowercase }"
                  >
                    <i
                      class="frmIcon fa"
                      :class="rec_has_lowercase ? 'fa-check' : 'fa-times'"
                    ></i>
                    دارای حروف کوچک باشد
                  </p>
                </b-col>
                <b-col>
                  <!-- NOTE check if the pass has number -->
                  <p class="pass" :class="{ 'pass--passed': rec_has_number }">
                    <i
                      class="frmIcon fa"
                      :class="rec_has_number ? 'fa-check' : 'fa-times'"
                    ></i>
                    دارای عدد باشد
                  </p>
                </b-col>
              </b-row>

              <!--============== checking password =========== -->
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  trim
                  type="password"
                  v-model="repeatNewPass"
                  class="form-control"
                  placeholder="تکرار رمز عبور جدید"
                  autofocus
                  @keyup.enter.native="
                    !busy && newPass && repeatNewPass && activationCode
                      ? resetPass()
                      : ''
                  "
                />
              </b-input-group>
              <b-row>
                <b-col cols="6">
                  <b-button
                    type="submit"
                    variant="primary"
                    @click="resetPass()"
                    style="border: 0"
                    :disabled="
                      busy || !(repeatNewPass && newPass && activationCode)
                    "
                  >
                    <i class="icon-login"></i>تغییر رمز </b-button
                  >&nbsp;
                </b-col>
                <b-col cols="6" class="text-left">
                  <!-- NOTE (b-sendAgain) to get the activation code again -->
                  <b-button
                    type="submit"
                    variant="info"
                    @click="sendCode()"
                    style="border: 0"
                    :disabled="sendAgainDisbaled"
                  >
                    <b-icon icon="arrow-counterclockwise"></b-icon>ارسال مجدد کد
                    <span v-if="countdown != 0">{{ toHHMMSS(countdown) }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!-- reset pass  -->
    <b-toast
      id="example-toast"
      title="نام کاربری و رمز عبور نادرست است"
      static
      no-auto-hide
      >نام کاربری و رمز عبور نادرست است</b-toast
    >

    <div class="container">
      <b-row class="justify-content-center">
        <h1 class="mb-5 text-white" style="color: #fff">
          دانشگاه گرامی، به سامانه تقسیم کار ملی خوش آمدید!
        </h1>

        <b-col md="8">
          <b-card-group>
            <b-card no-body class="login-card p-4">
              <b-card-body>
                <p class="text-muted">
                  برای ورود به سیستم،لطفا نام کاربری و رمز ورود خود را وارد
                  نمایید.
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    trim
                    type="text"
                    v-model="username"
                    class="form-control"
                    placeholder="نام کاربری"
                    @keyup.enter.native="gotoDashboard"
                  />
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    trim
                    type="password"
                    v-model="password"
                    class="form-control"
                    placeholder="رمز ورود"
                    autocomplete="current-password"
                    @keyup.enter.native="
                      !busy && username && password ? gotoDashboard() : ''
                    "
                  />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <!-- NOTE (b-login) to go to the university dashboard -->
                    <b-button
                      v-if="!isBusy"
                      type="submit"
                      variant="primary"
                      @click="gotoDashboard()"
                      style="border: 0"
                      :disabled="busy || isBusy || !username || !password"
                      class="btn-radius px-8 py-2 mt-4"
                    >
                      <i class="icon-login"></i>ورود
                    </b-button>

                    <b-spinner v-else class="align-middle"></b-spinner>
                  </b-col>
                  <b-col>
                    <a
                      class="text-primary mt-4"
                      style="float: left; cursor: pointer"
                      @click="showResetPass()"
                      :disabled="isBusy"
                      >رمز عبور خود را فراموش کرده اید؟</a
                    >
                  </b-col>

                  <b-col cols="6" class="text-right"></b-col>
                </b-row>
              </b-card-body>
              <div>
                <b-row></b-row>
              </div>
            </b-card>
          </b-card-group>
          <b-row class="justify-content-center mt-5">
            <v-btn
              color="indigo lighten-2"
              @click="goTo('admin')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود مدیر
            </v-btn>
            <v-btn
              color="red darken-3"
              @click="goTo('ref')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود داور
            </v-btn>
            <v-btn
              color="deep-orange lighten-1"
              @click="goTo('accelerator')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شتاب‌دهنده
            </v-btn>
            <v-btn
              color="indigo"
              @click="goTo('company')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شرکت
            </v-btn>
            <v-btn
              color="purple darken-1"
              @click="goTo('researcher')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود پژوهشگر
            </v-btn>
          </b-row>
          <hr class="mt-6" />
          <b-row class="justify-content-center mt-3">
            <v-btn
              color="blue darken-1"
              to="/map"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              <v-icon class="me-1">mdi-map</v-icon>نقشه تعاملی زیست فناوری
            </v-btn>
            <v-btn
              color="yellow darken-1"
              class="m-1 black--text btn-radius"
              height="42"
              elevation="0"
              @click="faqDialog = true"
            >
              <v-icon class="me-1">mdi-frequently-asked-questions</v-icon>سوالات
              متداول
            </v-btn>
            <v-btn
              color="orange darken-1"
              href="https://api.biodcportal.com/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              راهنمای آشنایی با طرح تقسیم کار ملی زیست فناوری
            </v-btn>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <ChangeLog />
    <FaqDialogue :faq-dialog.sync="faqDialog" />
  </div>
</template>

<script>
import router from "../router"; // NOTE (IMPORT) to communication between different parts of the site
import md5 from "js-md5";
const FaqDialogue = () => import("../components/FaqDialogue");

export default {
  name: "Login",
  components: { FaqDialogue },
  data() {
    return {
      username: "",
      password: "",
      busy: false,
      isBusy: false,

      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      rec_has_number: false,
      rec_has_lowercase: false,
      rec_has_uppercase: false,
      faqDialog: false,
    };
  },
  watch: {
    codeSent: function (val, oldVal) {
      // NOTE (w-codeSent) to give the code again after 60 second
      this.countdown = 60;

      if (val == true) {
        this.sendAgainDisbaled = true;
        this.countDownTimer();
      }
    },
    countdown: function (val, oldVal) {
      // NOTE (w-countdown) to countdown for sending code again
      if (val == 0) {
        this.sendAgainDisbaled = false;
      } else {
        this.sendAgainDisbaled = true;
      }
    },
  },
  computed: {
    passStrength() {
      this.rec_has_number = /\d/.test(this.newPass);
      this.rec_has_lowercase = /[a-z]/.test(this.newPass);
      this.rec_has_uppercase = /[A-Z]/.test(this.newPass);
    },
  },
  methods: {
    goTo(role) {
      if (role == "admin") {
        this.$router.push("/adminloginsolid");
      } else if (role == "ref") {
        this.$router.push("/refloginsolid");
      } else if (role == "researcher") {
        this.$router.push("/loginsolid");
      } else if (role == "company") {
        this.$router.push("/companyLoginsolid");
      } else if (role == "accelerator") {
        this.$router.push("/acceleratorLoginsolid");
      }
    },
    gotoDashboard() {
      // NOTE (m-gotoDashboard) to go to the dashboard
      this.isBusy = true;
      this.$http
        .post(this.baseUrl + "/setad/authentication/uniLogin", {
          username: this.username,
          password: md5(this.password),
        })
        .then((res) => {
          this.isBusy = false;

          if (res.status == 200) {
            localStorage.setItem("userId", res.data.token);
            localStorage.setItem("role", "university");
            localStorage.setItem("username", res.data.name);
            localStorage.setItem("isCatComplete", res.data.isCatComplete);
            this.$route.query.return
              ? this.$router.push(this.$route.query.return)
              : this.$router.push("/university/dashboard");
          } else {
            const title = (
              <div>
                <h5>خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    showResetPass() {
      this.$refs["resetPassModal"].show();
    },
    closeResetPass() {
      this.$refs["resetPassModal"].hide();
      this.username = "";
      this.activationCode = "";
      this.newPass = "";
      this.repeatNewPass = "";
      this.codeSent = false;
    },
    sendCode() {
      // NOTE (m-sendCode) to send the code
      this.codeSent = false;
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/setad/authentication/uniSenCode", {
          username: this.username,
        })
        .then(() => {
          this.codeSent = true;
          this.busy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    resetPass() {
      if (
        this.rec_has_number &&
        this.rec_has_lowercase &&
        this.rec_has_uppercase &&
        this.newPass.length > 7
      ) {
        if (this.newPass == this.repeatNewPass) {
          this.busy = true;
          this.$http
            .post(this.baseUrl + "/setad/authentication/uniResPass", {
              username: this.username,
              password: md5(this.newPass),
              activationCode: this.activationCode,
            })
            .then((res) => {
              this.toast(res.data, "success");
              this.busy = false;
              this.$refs["resetPassModal"].hide();
            })
            .catch((err) => {
              console.log(err);
              this.toast(err.response.data, "error");
              this.busy = false;
            });
        } else {
          this.toast("رمز عبور و تکرار آن باید منطبق باشند", "error");
        }
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.uniBack {
  background-image: url("../assets/images/uniBack.png");

  background-size: cover;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
</style>
